<template>
<div>
	<div class="banner">
		<img src="/static/images/banner.jpg" alt="">
		<!-- <BannerQrCode class="bannerQrcode"/> -->
	</div>
	<div class="main">
		<div class="repair-title">
			<div class="text">
				提示：要求详细阅读产品方案和保险条款，以方案和条款为准
			</div>
		</div>
		
		<div class="acProductList clear">
			<div class="acProductList-item l" @click="toDetail('person')">
				<div class="acProductList-item-title">货车雇主责任险-按人投保</div>
				<div class="acProductList-item-subtitle"><span>XXXXXXXXXXXXXXXXXXXXXXXXXXX</span></div>
				<div class="acProductList-item-desc">XXXXXXXXXXXXXXXXXXXXXXXXXXX</div>
				<div class="acProductList-item-bottom clear">
					<div class="l">
						<span class="num">490</span>元/人/年起
					</div>
					<div class="r">
						<a class="p-btn">查看详情</a>
					</div>
				</div>
			</div>
			<div class="acProductList-item l" @click="toDetail('car')">
				<div class="acProductList-item-title">货车雇主责任险-按车投保</div>
				<div class="acProductList-item-subtitle"><span>XXXXXXXXXXXXXXXXXXXXXXXXXXX</span></div>
				<div class="acProductList-item-desc">XXXXXXXXXXXXXXXXXXXXXXXXXXX</div>
				<div class="acProductList-item-bottom clear">
					<div class="l">
						<span class="num">700</span>元/座/年起
					</div>
					<div class="r">
						<a class="p-btn">查看详情</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
// import BannerQrCode from '../components/common/BannerQrCode'
export default {
	// components:{BannerQrCode},
	data(){
		return {
		}
	},
	created(){

	},
	methods:{
		toDetail(type) {
			this.$router.push(`/truck-employer/${type}`)
		},
	}
}
</script>
<style scoped lang="less">
	.banner{
		width:100%;
		font-size: 0;
		position: relative;
		img{
			width:100%;
		}
		.bannerQrcode{
			position: absolute;
			right: 10%;
			top:0;
			bottom: 0;
			margin: auto 0;
			color:#fff;
		}
	}
	.main{
		background:none;
		padding-top: 40px;
		&-title{
			text-align:center;
			font-size: 0;
			margin-top: 40px;
			img{
				height:29px;
			}
		}
	}
	.repair {
		// height:330px;
		// margin-bottom: 60px;
		// box-shadow: 0 0 25px rgba(0,0,0,.1);
		// overflow:hidden;
		&-title{
			padding-bottom: 20px;
			color:red;
			.text{
				width: 880px;
				text-indent: 2em;
			}
		}
	}
	.acProductList{
        margin-top: 30px;
        width: 1213px;
        &-item{
            width:290px;
            margin-right: 13px;
            padding: 30px 15px 10px 15px;
            background:#fff;
            transition:all .2s;
            margin-bottom: 30px;
            cursor: pointer;
            &-title{
                font-size: 18px;
            }
            &-subtitle{
				font-size: 22px;
				overflow: hidden;
                span{
                    display:inline-block;
                    padding: 15px 0;
                    border-bottom: 1px solid #4386f6;
                }
            }
            &-desc{
                margin-top: 15px;
                height:165px;
                font-size: 15px;
                color:#999;
                line-height:1.7;
                &.textMore{
                    font-size: 14px;
                    white-space: nowrap;
                }
                &.small{
                    height: 100px;
                }
            }
            &-bottom{
                padding: 15px 0;
                border-top: 1px solid #eee;
                font-size: 14px;
                color:#666;
                .l>.num{
                    font-size: 26px;
                    color:#ea544a;
                }
            }
        }
        &-item:last-child{
            margin-right: 0;
        }
        &-item:hover{
            box-shadow: 0 0 15px rgba(0,0,0,.1);
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/Index.vue